import { isPlaceholderProjectThumbnail } from "./filePathUtils";

type ThumbnailTracePayload = Record<
  string,
  string | number | boolean | null | undefined
>;

export type ThumbnailUrlKind =
  | "missing"
  | "placeholder"
  | "project"
  | "other";

export const sanitizeThumbnailTraceUrl = (
  value: string | null | undefined,
): string | null => {
  if (!value) return null;
  return (
    value.replace(/(https?:\/\/[^\s?#]+)[?#][^\s]*/gi, "$1") || null
  );
};

export const classifyThumbnailUrl = (
  value: string | null | undefined,
): ThumbnailUrlKind => {
  if (!value) return "missing";
  if (isPlaceholderProjectThumbnail(value, null)) return "placeholder";
  const sanitized = sanitizeThumbnailTraceUrl(value) || "";
  if (/viewr-project-files[^/]*\/.*\.png$/i.test(sanitized)) {
    return "project";
  }
  return "other";
};

/** Production 재현 로그도 RTF export에서 접히지 않도록 한 줄 JSON 문자열로 기록한다. */
export const traceProjectThumbnail = (
  event: string,
  payload: ThumbnailTracePayload,
): void => {
  if (process.env.NODE_ENV === "test") return;

  const sanitizedPayload = Object.fromEntries(
    Object.entries(payload).map(([key, value]) => [
      key,
      typeof value === "string"
        ? sanitizeThumbnailTraceUrl(value) ?? value
        : value,
    ]),
  );
  console.info(
    `[ThumbnailTrace] ${event} ${JSON.stringify(sanitizedPayload)}`,
  );
};
